import React from 'react';
import AppContainer from '../app-container';
import * as participantActions from '../../actions/participant';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import Loading from '../../components/loading';
import {paymentUrl} from '../../utils/url';
import ReactPixel from 'react-facebook-pixel';

class StageRegistrationPageContainer extends AppContainer {

    componentWillMount() {
        this.props.actions.fetchParticipantByUuid(this.props.params.itemUuid).then(this.handlePageResult.bind(this)).then(this.trackEvent.bind(this));
    }

    trackEvent(){
        const {participant} = this.props;
        if (participant.payment.payed && window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
            ReactPixel.track('complete-checkout', {participant: participant.id})
        }
    }

    renderPayText() {
        const {participant} = this.props;
        if (participant.payment.payed) {
            return (
                <div>{LocalizedStrings.registeredSuccessfullyAndGotPayment}
                </div>
            )
        } else {
            if(!participant.can_pay){
                return null
            }
        }
        return (
            <div>
                <div>
                    {LocalizedStrings.registeredSuccessfullyAndNeedToPay}
                    {participant.payment.price}
                    EUR.
                </div>
                <a href={paymentUrl(participant.uuid)} className="btn btn-main-color mt-20">{LocalizedStrings.pay} {participant.payment.price}
                    EUR</a>
            </div>
        )
    }

    renderFreeText() {
        return (
            <div>{LocalizedStrings.registeredSuccessfully}</div>
        )
    }

    renderParticipantInfo() {
        const {participant} = this.props;
        return (
            <table className="table" style={{
                marginTop: '20px'
            }}>
                <tbody>
                    <tr>
                        <td className="first-uppercase">{LocalizedStrings.participant}</td>
                        <td>{participant.displayName}</td>
                    </tr>
                    <tr>
                        <td className="first-uppercase">{LocalizedStrings.distance}</td>
                        <td>{participant.distance
                                ? participant.distance.name
                                : ''}</td>
                    </tr>
                </tbody>

            </table>
        )
    }

    render() {
        const {participant, loading} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.registeredSuccessfully)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.registeredSuccessfully}</span>
                        </h1>
                        {loading
                            ? <Loading/>
                            : <div>

                                {participant.payment && participant.payment.price > 0
                                    ? this.renderPayText()
                                    : this.renderFreeText()}
                                {this.renderParticipantInfo()}
                            </div>}

                    </div>
                </div>
            </DocumentTitle>

        )

    }
}
export default connect(function(state) {
    return {participant: state.participant.participant, loading: state.participant.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(StageRegistrationPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/participant-page-container.js